/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Exercise from './Exercise';
import NewExercise from './NewExercise';
import { useStateValue } from '../ContextApi/StateProvider';
import './components.css';

const WorkoutPage = (props) => {
  const [initialState, dispatch] = useStateValue();
  const [workout, setWorkout] = useState({});
  const [exercises, setExercises] = useState([]);
  const authUser = JSON.parse(initialState.authenticatedUser);

  useEffect(() => {
    initialState.WorkoutRequests.getWorkout(
      props.match.params.id,
      authUser.emailAddress,
      authUser.password
    )
      .then((response) => setWorkout(response))
      .catch((err) => console.log('Error: ' + err));
  }, []);

  useEffect(() => {
    initialState.ExerciseRequests.getExercises(
      props.match.params.id,
      authUser.emailAddress,
      authUser.password
    )
      .then((response) => setExercises(response))
      .catch((err) => console.log('Error: ' + err));
  }, []);

  const updateExercises = () => {
    initialState.ExerciseRequests.getExercises(
      props.match.params.id,
      authUser.emailAddress,
      authUser.password
    )
      .then((response) => setExercises(response))
      .catch((err) => console.log('Error: ' + err));
  };

  const openForm = () => {
    dispatch({ type: 'SET_EXERCISE_FORM_OPEN', exerciseFormOpen: true });
  };

  const closeForm = () => {
    dispatch({ type: 'SET_EXERCISE_FORM_OPEN', exerciseFormOpen: false });
  };

  const deleteWorkout = () => {
    if (authUser.userId === workout.userId) {
      if (
        window.confirm(
          'Are you sure you want to delete this workout? Once deleted, it cannot be retrieved.'
        )
      ) {
        initialState.WorkoutRequests.deleteWorkout(
          workout.id,
          authUser.emailAddress,
          authUser.password
        )
          .then((response) => {
            if (response === 'success') {
              props.history.push('/home');
              alert('Workout deleted.');
            } else {
              props.history.push('/error');
            }
          })
          .catch((err) => {
            console.log(err);
            props.history.push('/error');
          });
      }
    } else {
      alert('You are not authorized to delete this workout.');
    }
  };

  if (!authUser) return <Redirect to="/sign-in" />;

  return (
    <div className="workout-container">
      <div className="container-2025 section-2025 prose-2025 space-y-2 leading-relaxed">
        <div className="space-y-1.5">
          <h1 className="text-2xl font-semibold leading-snug">{workout.title}</h1>
          <p>{workout.description}</p>
          <p className="text-zinc-500 dark:text-zinc-400">{workout.time}</p>
        </div>

        {initialState.exerciseFormOpen && (
          <NewExercise
            workoutId={props.match.params.id}
            updateFunction={updateExercises}
          />
        )}

        <div className="grid-2025">
          <div className="workout-button-container">
            {initialState.exerciseFormOpen ? (
              <div
                className="workout-new-button cancel"
                tabIndex={1}
                onClick={closeForm}
              >
                <p>
                  <i className="fas fa-times-circle"></i> Cancel
                </p>
              </div>
            ) : (
              <div
                className="workout-new-button"
                tabIndex={1}
                onClick={openForm}
              >
                <p>
                  <i className="fas fa-plus-circle"></i> Add Exercise
                </p>
              </div>
            )}

            <div className="workout-edit-button" tabIndex={1}>
              <Link
                to={`/workouts/${props.match.params.id}/edit`}
                className="link"
              >
                <p>
                  <i className="fas fa-edit"></i> Edit Workout
                </p>
              </Link>
            </div>

            <div
              className="workout-delete-button"
              tabIndex={1}
              onClick={deleteWorkout}
            >
              <p>
                <i className="fas fa-trash-alt"></i> Delete
              </p>
            </div>
          </div>

          {exercises.map((exercise) => (
            <Exercise
              key={exercise.id}
              workoutId={props.match.params.id}
              id={exercise.id}
              title={exercise.title}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkoutPage;
